import React from 'react';
import { Section } from './ui';
export const Problem = () => {
  return <Section className="bg-white" data-id="element-130">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-semibold text-center mb-10 leading-tight" data-id="element-131">
        El gran engaño de la repostería “saludable”
      </h2>

      <div className="relative max-w-md mx-auto mb-12 rounded-2xl overflow-hidden shadow-soft" data-id="element-132">
        <img src="https://cdn.magicpatterns.com/uploads/ucbxN42J1yAwR3vYQr4xB1/image.png" alt="Mujer frustrada con pastel fallido" className="w-full h-auto block" data-id="element-133" />
      </div>

      <div className="max-w-xl mx-auto mb-12" data-id="element-134">
        <div className="space-y-6" data-id="element-135">
          <p className="text-xl font-medium text-center" data-id="element-136">
            Nos dijeron que todo se solucionaba con:
          </p>
          <ul className="space-y-3 text-lg text-gray-700 max-w-sm mx-auto" data-id="element-137">
            <li className="flex items-center gap-3" data-id="element-138">
              <span className="text-brand-red" data-id="element-139">❌</span> Harinas especiales
            </li>
            <li className="flex items-center gap-3" data-id="element-140">
              <span className="text-brand-red" data-id="element-141">❌</span> Sustitutos caros
            </li>
            <li className="flex items-center gap-3" data-id="element-142">
              <span className="text-brand-red" data-id="element-143">❌</span> Recetas complicadas
            </li>
          </ul>
        </div>
      </div>

      <div className="text-center max-w-3xl mx-auto space-y-6" data-id="element-144">
        <p className="text-lg sm:text-xl md:text-2xl font-serif italic text-gray-800 leading-snug" data-id="element-145">
          Pero puedes usar la mejor harina del mundo y aun así terminar con un
          pastel que nadie quiere repetir.
        </p>

        <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100 shadow-sm" data-id="element-146">
          <p className="text-lg sm:text-xl font-bold mb-3" data-id="element-147">¿Por qué?</p>
          <p className="text-base sm:text-lg" data-id="element-148">
            Porque un pastel sin gluten{' '}
            <span className="text-brand-red underline font-bold" data-id="element-149">
              no funciona
            </span>{' '}
            como uno tradicional.
          </p>
        </div>
      </div>
    </Section>;
};